import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { initPdfAB, pdfPageScrollExitModal18683Variant } from '@/services/ab'
import { setupSignupModalEventListeners } from '@/pages-signup-modal/show-modal.helpers'

const headerJS = require('@/assets.v2/js/header.js')
const { header } = headerJS

export function initPagePdf(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', async function () {
    header()
    await initPdfAB()

    if (pdfPageScrollExitModal18683Variant() === 'B') {
      setupSignupModalEventListeners()
    }

    Mixpanel.pageView()
  })
}
